import { render, staticRenderFns } from "./titelbild_simple.vue?vue&type=template&id=3e546e07&scoped=true"
import script from "./titelbild_simple.vue?vue&type=script&lang=js"
export * from "./titelbild_simple.vue?vue&type=script&lang=js"
import style0 from "./titelbild_simple.vue?vue&type=style&index=0&id=3e546e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e546e07",
  null
  
)

export default component.exports